import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const usePasswordSchema = () => {
  const { t } = useTranslation(['validation']);

  return z
    .object({
      password: z
        .string()
        .min(
          8,
          t('validation:password.minChar', {
            chars: 8,
          }),
        )
        .regex(/[0-9]/, t('validation:password.atLeast1Number'))
        .regex(/[a-z]/, t('validation:password.atLeast1LowerCaseLetter'))
        .regex(/[A-Z]/, t('validation:password.atLeast1UpperCaseLetter'))
        .regex(
          new RegExp('.*[`~<>?,./!@#$%^&*()\\-_+="\'|{}\\[\\];:\\\\].*'),
          t('validation:password.atLeast1SpecialCharacter'),
        ),
      passwordConfirmation: z.string().min(1, t('validation:required')),
    })
    .refine(data => data.password === data.passwordConfirmation, {
      message: t('validation:password.passwordMustMatch'),
      path: ['passwordConfirmation'],
    });
};
